__turbopack_context__.v({
  "dark": "CjTXxq_dark",
  "divider": "CjTXxq_divider",
  "left": "CjTXxq_left",
  "light": "CjTXxq_light",
  "primary": "CjTXxq_primary",
  "right": "CjTXxq_right",
  "secondary": "CjTXxq_secondary",
});
